import { ServiceList } from 'components/templates/MyPageTemplate';

// テキスト
export const GAKKEN_ID_FAQ_LINK_TEXT = 'GakkenIDのよくあるご質問';

// URL
export const DUPLICATION_LINK_URL_FOR_MAILADDRESS = 'https://id.gakken.jp/faq.html?_anchor=q-b-03';

// サービスリスト
// この配列の並び順で表示している。3つ区切り
export const SERVICE_LIST: ServiceList[] = [
	{
		serviceName: '学研モール',
		url: 'https://gakken-mall.jp/',
		logoPath: 'images/service-mall.png',
		textMessage:
			'Gakken Mall（学研モール）は、学研が発行する書籍や保育用品、大学受験教材を購入いただける、学研グループ公式のオンラインショッピングモールです。',
	},
	{
		serviceName: 'Shikaku Pass',
		url: 'https://shikakupass.com/',
		logoPath: 'images/logo-shikakupass02.png',
		textMessage:
			'社会人のための、スマホで資格学習できるオンラインサービスです。 動画によるプロ講師の丁寧なレクチャーと、厳選された過去問演習でスピード合格を目指すことができます。',
	},
	{
		serviceName: '学研ライブラリー',
		url: 'https://gk-library.gakken.jp/',
		logoPath: 'images/logo-gakkenlibrary02-pay.png',
		textMessage:
			'学研ライブラリーは、学研グループが発行する電子書籍の中から、子どもの興味・関心を引き出し、知的好奇心を育む書籍が定額で読めるサブスクリプションサービスです。',
	},

	{
		serviceName: '地球の歩き方コミュニティ',
		url: 'https://community.arukikata.co.jp/',
		logoPath: 'images/logo-arukikata-community.png',
		textMessage:
			'誰もが気軽に交流できる「地球の歩き方」の公式コミュニティ。旅好きが集い、語り合い、次の旅へのヒントが見つかる場所。会員限定特典やコンテンツも多数掲載しています。',
	},
	{
		serviceName: '学研の幼児ワーク できたーず',
		url: 'https://kosodatemap.gakken.jp/ganbari-dekitars/',
		logoPath: 'images/logo-dekitars02-transparency.png',
		textMessage:
			'「学研の幼児ワーク」の無料サービスです。5冊取り組むと貰える「がんばり賞」のWEB応募や、ペット「できたーず」の育成、取り組んだワークの記録などができます。',
	},
	{
		serviceName: '学研のプライム講座',
		url: 'https://gpzemi.gakken.jp/',
		logoPath: 'images/service-gpzemi.png',
		textMessage:
			'全国の高校生一人ひとりの学力や個性に応じた最適な学びのコンテンツ・サービスを提供する「学び」のプラットホームです。',
	},

	{
		serviceName: '学研の科学と学習 あそぶんだ研究所',
		url: 'https://gakkenplus.commmune.com/view/signin',
		logoPath: 'images/service-asobunda.png',
		textMessage:
			'「学研の科学」と「学研の学習」の無料会員制オンラインコミュニティです。スマホやPC で学研の科学や学習をもっと楽しもう！',
	},
	{
		serviceName: 'Gakken Book Contents Library',
		url: 'https://gbc-library.gakken.jp/',
		logoPath: 'images/logo-gbclibrary01.png',
		textMessage:
			'Gakkenの商品・サービスに関するコンテンツやプレゼントキャンペーン等へのご参加をお楽しみいただけるWebサイトです。',
	},
	{
		serviceName: 'こそだてまっぷ',
		url: 'https://kosodatemap.gakken.jp/',
		logoPath: 'images/service-kosodate-map.png',
		textMessage:
			'未就学から小学生のお子さんのママ＆パパに向けた、「こそだて」を応援する総合サイトです。お子さんの学びや成長のヒントとなる情報や体験をお届けします。',
	},
];
